/* DASKI common - 全ページ共通 JS */

/* スクロール表示（.daski-reveal → .is-visible） */
(function () {
  const supported = 'IntersectionObserver' in window;
  const io = supported
    ? new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px' }
      )
    : null;

  function observe(root) {
    root.querySelectorAll('.daski-reveal:not(.is-visible)').forEach((el) => {
      if (io) io.observe(el);
      else el.classList.add('is-visible');
    });
  }

  observe(document);

  // テーマエディタでセクション再描画時にも適用
  document.addEventListener('shopify:section:load', (e) => observe(e.target));
})();

/* 商品カードのカラースウォッチ → クリックで画像＆リンク先を切替 */
(function () {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.daski-card__swatch');
    if (!btn) return;
    const card = btn.closest('.daski-card');
    if (!card) return;

    const img = card.querySelector('.daski-card__img:not(.daski-card__img--secondary)');
    if (img && btn.dataset.imgSrc) {
      img.src = btn.dataset.imgSrc;
      if (btn.dataset.imgSrcset) img.srcset = btn.dataset.imgSrcset;
      if (btn.dataset.imgAlt != null) img.alt = btn.dataset.imgAlt;
    }

    // カード内の各リンク先を選択カラーのバリアントURLへ
    if (btn.dataset.url) {
      card.querySelectorAll('.daski-card__media, .daski-card__title').forEach((a) => {
        a.href = btn.dataset.url;
      });
    }

    card.querySelectorAll('.daski-card__swatch').forEach((b) => b.classList.remove('is-active'));
    btn.classList.add('is-active');
  });
})();
